import React, { useState } from "react";
import RoundedButton from "./components/RoundedButton/RoundedButton";
import AuthCard from "./components/AuthCard/AuthCard";
import ImpactNumbers from "./sections/ImpactNumbers/ImpactNumbers";
import clsx from "clsx";

const Banner = ({ history, location }) => {
  const [view, setView] = useState("collapsed");

  const handleLoginSignUpClick = () => {
    setView("options");
  };

  const handleCollapseAuthCard = () => {
    setView("collapsed");
  };

  return (
    <section className={`landing-banner ${view}`}>
      <div className="banner-container">
        <div className={clsx("description-column", { "collapsed-description": view === "options" })}>
          <p>
            OMICON is a portal for the collaborative study of gene coexpression
            networks in the human brain. It was created by the Oldham Lab, which
            is part of the Department of Neurological Surgery at UCSF.
          </p>
        </div>
        <div className="auth-column">
          {view === "collapsed" && (
            <RoundedButton text="Login / Sign Up" onClick={handleLoginSignUpClick} showArrow/>
          )}
          {view === "options" && (
            <AuthCard onCollapse={handleCollapseAuthCard} history={history} />
          )}
        </div>
      </div>
      <ImpactNumbers />
    </section>
  );
};

export default Banner;
